// We importeren React-functies die we nodig hebben
import { createContext, useEffect, useState } from 'react';
// We importeren PapaParse — een handige library om CSV-bestanden te lezen
import Papa from 'papaparse';

// We maken een nieuwe context aan die we in andere componenten kunnen gebruiken
// Dit zorgt ervoor dat data uit het CSV-bestand overal in de applicatie beschikbaar is
export const CsvDataContext = createContext();

// Dit is de "provider"-component die de data laadt en beschikbaar stelt
export const CsvDataProvider = ({ children }) => {
    // 🔹 State-variabelen:
    // rawData → bevat alle rijen uit het CSV-bestand
    // loading → geeft aan of de data nog aan het laden is
    const [rawData, setRawData] = useState([]);
    const [loading, setLoading] = useState(true);

    // useEffect zorgt ervoor dat de CSV-data wordt ingeladen zodra de app start
    useEffect(() => {
        // 📄 Het CSV-bestand staat in de public-map, in /public/data/data.csv
        // Tijdens runtime wordt dat bestand bereikbaar via de URL /data/data.csv
        Papa.parse("/data/data.csv", {
            download: true, // Zorgt ervoor dat PapaParse het bestand ophaalt via HTTP
            header: true,   // Leest de eerste rij van de CSV als kolomnamen
            complete: (result) => {
                // Wanneer het inladen klaar is, tonen we in de console hoeveel regels zijn ingelezen
                console.log("CSV loaded rows:", result?.data?.length ?? 0);

                // We slaan alle rijen op in onze state
                setRawData(result.data);

                // En we zetten loading op false zodat de app weet dat het klaar is
                setLoading(false);
            },
            // Als er iets misgaat met het inladen, loggen we de fout in de console
            error: (error) => {
                console.error("Error parsing CSV:", error);
                setLoading(false);
            },
        });
    }, []); // 🔁 De lege array [] betekent dat dit effect maar één keer draait bij het opstarten

    // Hier "omwikkelen" we de hele app met deze context
    // Daardoor kunnen andere componenten (zoals DefensiveAction) rawData en loading gebruiken
    return (
        <CsvDataContext.Provider value={{ rawData, loading }}>
            {children}
        </CsvDataContext.Provider>
    );
};
